import { useMemo } from 'react';

import { Factory } from '..';
import { useDataState } from '../../../data';

import type { NumberProps } from '@eventespresso/ui-components';

export const FormattedPrice = ({ isDisabled, ...props }: NumberProps) => {
	const { ticket, updateTicketPrice } = useDataState();

	const ariaLabel = useMemo(() => {
		return props['aria-label'] ? { 'aria-label': props['aria-label'] } : {};
	}, [props]);

	return (
		<Factory
			_type='Money'
			{...props}
			{...ariaLabel}
			amount={ticket.price ?? 0}
			disabled={isDisabled}
			name='ticket.price'
			min={0}
			onUpdate={updateTicketPrice}
		/>
	);
};
